import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PagesService } from '../services/pages.service';
import { Page } from '../interfaces/pages.interface';
import { Subscription } from 'rxjs';
import { Location } from '@angular/common';

@Component({
  selector: 'app-page',
  standalone: false,
  templateUrl: './page.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./page.component.scss']
})
export class PageComponent implements OnInit {
  page?: Page;
  private pageSub?: Subscription;
  private routeSub?: Subscription;

  constructor(
    private route: ActivatedRoute,
    private pagesService: PagesService,
    private location: Location
  ) {}

ngOnInit(): void {
    this.routeSub = this.route.paramMap.subscribe(params => {
      const id: number| string = params.get('id');
      if (id) {
        this.pageSub?.unsubscribe(); // Unsubscribe previous page request
        this.pageSub = this.pagesService.getPage(id).subscribe(page => {
          this.page = page;
          document.title = 'ZGrane Grono - ' +  page.title;
          // Set meta description from lead
          if (page.lead) {
            const metaDesc = document.querySelector('meta[name="description"]');
            if (metaDesc) {
              metaDesc.setAttribute('content', page.lead);
            } else {
              const meta = document.createElement('meta');
              meta.name = 'description';
              meta.content = page.lead;
              document.head.appendChild(meta);
            }
          }
        });
      }
    });
  }

  goBack(): void {
    this.location.back();
  }

  ngOnDestroy(): void {
    this.pageSub?.unsubscribe();
    this.routeSub?.unsubscribe();
  }
}